import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  accent: { color: colors.gilead.primary1 },
  textAreaWidth: { width: 200 },
  root: {
    width: 620,
    [theme.breakpoints.down('lg')]: {
      width: 580,
    },
    [theme.breakpoints.down('md')]: {
      width: 236,
    },
  },
  title: {
    width: '85%',
    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      width: 'initial',
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3.5),

    '& > button:nth-child(1)': {
      marginRight: theme.spacing(3.5),
      color: theme.palette.primary1,
    },
    '& > button:nth-child(2)': {
      width: 91,
    },
    [theme.breakpoints.down('lg')]: {
      '& > button:nth-child(2)': {
        width: 200,
      },
    },
    [theme.breakpoints.down('md')]: {
      '& > button:nth-child(2)': {
        width: 116,
        height: 44,
      },
    },
  },
  message: {
    color: '#54565B',
    fontSize: 18,
    marginTop: 10,
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      marginTop: 6,
      marginBottom: theme.spacing(2),
    },
  },
  textArea: {
    border: '1px solid #C6CAC6',
    borderRadius: 10,
    fontFamily: isKiteUser
      ? 'Helvetica, sans-serif'
      : 'Proxima Nova, sans-serif',
    fontSize: 16,
    padding: theme.spacing(1),
    width: '100% !important',
    outline: 0,
    resize: 'none',
    '&::placeholder': {
      color: '#C6CAC6',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
  fieldName: {
    fontWeight: 600,
    marginBottom: 6,
  },
  error: {
    color: colors.gilead.primary1,
    fontSize: 14,
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
    },
  },
}));
